import React from 'react';

import { isTrustedHtmlViolation, rememberTrustedHtmlFallbackForSession } from './trusted-types';

interface TrustedHtmlFallbackBoundaryProps {
  children?: React.ReactNode;
  fallback: React.ReactNode;
}

interface TrustedHtmlFallbackBoundaryState {
  trustedHtmlBlocked: boolean;
  unexpectedError: unknown;
}

export class TrustedHtmlFallbackBoundary extends React.Component<
  TrustedHtmlFallbackBoundaryProps,
  TrustedHtmlFallbackBoundaryState
> {
  state: TrustedHtmlFallbackBoundaryState = {
    trustedHtmlBlocked: false,
    unexpectedError: null,
  };

  static getDerivedStateFromError(error: unknown): TrustedHtmlFallbackBoundaryState {
    if (isTrustedHtmlViolation(error)) {
      return { trustedHtmlBlocked: true, unexpectedError: null };
    }
    return { trustedHtmlBlocked: false, unexpectedError: error };
  }

  componentDidCatch(error: unknown): void {
    if (isTrustedHtmlViolation(error)) {
      rememberTrustedHtmlFallbackForSession();
    }
  }

  render(): React.ReactNode {
    if (this.state.unexpectedError) throw this.state.unexpectedError;
    if (this.state.trustedHtmlBlocked) return this.props.fallback;
    return this.props.children;
  }
}
